var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('TopBar'),_c('LeftMenu'),_c('div',{staticClass:"pa-5"},[_c('h1',[_vm._v("Welcome!")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }